// src/components/AdBlockerModal.js
import React, { useState, useEffect } from 'react';
import './AdBlockerModal.css';

function AdBlockerModal({ currentLanguage, getLocalizedText }) {
  const [showModal, setShowModal] = useState(false);
  const t = (ar, en) => getLocalizedText(ar, en);

  useEffect(() => {
    // عنصر "طعم" بأسماء كلاسات شائعة بتستخدمها الـ Ad blockers كفلتر
    const bait = document.createElement('div');
    bait.className =
      'adsbox ad-banner ads advertisement adsbygoogle textAd ad_unit banner_ad';
    bait.style.cssText =
      'width:1px;height:1px;position:absolute;left:-9999px;top:-9999px;';
    document.body.appendChild(bait);

    const timer = setTimeout(() => {
      const style = document.body.contains(bait)
        ? window.getComputedStyle(bait)
        : null;

      const isBlocked =
        !document.body.contains(bait) ||
        bait.offsetHeight === 0 ||
        bait.offsetWidth === 0 ||
        (style && (style.display === 'none' || style.visibility === 'hidden'));

      if (isBlocked) setShowModal(true);

      if (document.body.contains(bait)) {
        document.body.removeChild(bait);
      }
    }, 400); // وقت كافي عشان الإضافة تتصرف

    return () => {
      clearTimeout(timer);
      if (document.body.contains(bait)) document.body.removeChild(bait);
    };
  }, []);

  const handleClose = () => setShowModal(false);

  if (!showModal) return null;

  return (
    <div className="adblock-modal-overlay">
      <div className={`adblock-modal ${currentLanguage === 'ar' ? 'ar' : 'en'}`}>
        <button className="adblock-modal-close" onClick={handleClose} aria-label="Close">
          ×
        </button>

        <div className="adblock-modal-icon">🛡️</div>

        <h2 className="adblock-modal-title">
          {t('يبدو أن هناك مانع اعلانات مُفَعَّل', 'Looks like an Ad Blocker is active')}
        </h2>

        <p className="adblock-modal-desc">
          {t(
            'لاحظنا إن بعض عناصر الموقع تختفي بسبب مانع الإعلانات. رجاءً عطّله أو أضف الموقع للاستثناءات لكي يعمل الموقع بكفاءة.',
            'We noticed some parts of the site are being hidden by an ad blocker. Please disable it or whitelist this site so everything works properly.'
          )}
        </p>

        <button className="adblock-modal-btn" onClick={handleClose}>
          {t('حسنًا، فهمت', 'Got it')}
        </button>
      </div>
    </div>
  );
}

export default AdBlockerModal;